import { useQuery } from '@tanstack/react-query';

import { readShigoAppConfig } from '../../lib/config';
import { useShigoSession } from '../../lib/useShigoSession';
import { createDashboardPublishersClient } from './api';

const dashboardPublishersQueryKey = ['dashboards', 'publishers'] as const;

export function useAssignedPublishersQuery(enabled = true) {
  const { session } = useShigoSession();
  const publisherIds = session?.user.publisherIds ?? [];
  const config = readShigoAppConfig();

  return useQuery({
    queryKey: [...dashboardPublishersQueryKey, [...publisherIds].sort()],
    queryFn: () => {
      if (!session) throw new Error('Shigo session is required.');
      return createDashboardPublishersClient({
        config: { apiBaseUrl: config.apiBaseUrl, networkId: config.networkId },
        accessToken: session.accessToken,
      }).listAssigned(publisherIds);
    },
    enabled: enabled && Boolean(session) && publisherIds.length > 0,
  });
}
